import { auth, setSessionInvalidatedHandler } from '../lib/api';
import { createAuthStore } from './authState';

const useAuthStore = createAuthStore(auth);
setSessionInvalidatedHandler(() => useAuthStore.getState().invalidateSession());
export default useAuthStore;
